import {TicketKind, TicketType} from '../../../../graphql/generated/types';

export function getTicketKindByTicketType(ticketType: TicketType) {
  return map[ticketType] || TicketKind.Unknown;
}

const map: {[key in TicketType]: TicketKind} = {
  [TicketType.BuyEvent]: TicketKind.Own,
  [TicketType.BuyNewCustomerGift]: TicketKind.Own,
  [TicketType.BuyTodayGift]: TicketKind.Own,
  [TicketType.BuySingle]: TicketKind.Own,
  [TicketType.BuyGiftFree]: TicketKind.Own,
  [TicketType.BuyPackage]: TicketKind.Own,
  [TicketType.BuyCampaign]: TicketKind.Own,
  [TicketType.BuyCoupon]: TicketKind.Own,
  [TicketType.BuyMoviePpv]: TicketKind.Own,
  [TicketType.BuyWaitFree]: TicketKind.Own,
  [TicketType.BuyWaitFreePlus]: TicketKind.Own,
  [TicketType.BuyCashSingle]: TicketKind.Own,
  [TicketType.BuyCashDiscountSingle]: TicketKind.Own,
  [TicketType.BuySet]: TicketKind.Own,
  [TicketType.RentSingle]: TicketKind.Rent,
  [TicketType.RentEvent]: TicketKind.Rent,
  [TicketType.RentGiftFree]: TicketKind.Rent,
  [TicketType.RentNewCustomerGift]: TicketKind.Rent,
  [TicketType.RentPackage]: TicketKind.Rent,
  [TicketType.RentWaitFree]: TicketKind.Rent,
  [TicketType.RentCampaign]: TicketKind.Rent,
  [TicketType.RentMoviePpv]: TicketKind.Rent,
  [TicketType.RentTodayGift]: TicketKind.Rent,
  [TicketType.RentWaitFreePlus]: TicketKind.Rent,
  [TicketType.RentCoupon]: TicketKind.Rent,
  [TicketType.RentCashSingle]: TicketKind.Rent,
  [TicketType.RentCashDiscountSingle]: TicketKind.Rent,
  [TicketType.RentSet]: TicketKind.Rent,
  [TicketType.Deactivate]: TicketKind.Unknown,
  [TicketType.Premium]: TicketKind.Unknown,
  [TicketType.WebSeries]: TicketKind.Unknown,
};
